import React, { useEffect, useState } from "react";
import { MessageCircle, MapPin, Store } from "lucide-react";
import { mk, money, ORDER_LABELS } from "../../../lib/marketApi";

const FLOW = ["paid", "preparing", "shipped", "ready", "delivered", "cancelled"];
const COLORS = { pending_payment: "bg-amber-100 text-amber-800", paid: "bg-emerald-100 text-emerald-800", preparing: "bg-blue-100 text-blue-800", shipped: "bg-indigo-100 text-indigo-800", ready: "bg-cyan-100 text-cyan-800", delivered: "bg-slate-200 text-slate-700", cancelled: "bg-red-100 text-red-700" };

export const OrdersTab = ({ sid, token, cur }) => {
  const [list, setList] = useState(null);
  const [filter, setFilter] = useState("paid_all");
  const load = () => mk(`/owner/${sid}/orders`, { token }).then(setList);
  useEffect(() => {
    load();
  }, [sid]); // eslint-disable-line react-hooks/exhaustive-deps

  const setStatus = async (o, status) => {
    await mk(`/owner/${sid}/orders/${o.id}`, { method: "PUT", token, body: { status } });
    load();
  };
  const shown = (list || []).filter((o) => (filter === "all" ? true : filter === "paid_all" ? o.payment_status === "paid" : o.status === filter));
  const revenue = (list || []).filter((o) => o.payment_status === "paid").reduce((s, o) => s + o.total, 0);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-2xl border border-slate-200 bg-white p-4"><p className="text-xs text-slate-500">Ventas pagadas</p><p className="text-xl font-bold text-slate-900" data-testid="orders-revenue">{money(revenue, cur)}</p></div>
        <div className="rounded-2xl border border-slate-200 bg-white p-4"><p className="text-xs text-slate-500">Pedidos pagados</p><p className="text-xl font-bold text-slate-900">{(list || []).filter((o) => o.payment_status === "paid").length}</p></div>
      </div>
      <select value={filter} onChange={(e) => setFilter(e.target.value)} className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm" data-testid="orders-filter">
        <option value="paid_all">Pagados (todos)</option>
        <option value="all">Todos, incluso sin pagar</option>
        {FLOW.map((s) => <option key={s} value={s}>{ORDER_LABELS[s]}</option>)}
      </select>
      {list && !shown.length && <p className="py-10 text-center text-sm text-slate-400" data-testid="orders-empty">No hay pedidos con este filtro. Cambia a "Todos" para ver también los pendientes de pago.</p>}
      <div className="space-y-3">
        {shown.map((o) => (
          <div key={o.id} className="space-y-3 rounded-2xl border border-slate-200 bg-white p-4" data-testid={`admin-order-${o.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-semibold text-slate-900">#{o.number} · {money(o.total, cur)}</p>
              <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${COLORS[o.status]}`}>{ORDER_LABELS[o.status]}</span>
            </div>
            <p className="text-sm text-slate-600">
              {o.buyer?.name} · {o.buyer?.email}
              {(o.phone || o.buyer?.phone) && (
                <a href={`https://wa.me/${(o.phone || o.buyer.phone).replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="ml-2 inline-flex items-center gap-1 text-emerald-600">
                  <MessageCircle className="h-3.5 w-3.5" /> WhatsApp
                </a>
              )}
            </p>
            <ul className="text-sm text-slate-700">{o.items.map((it) => <li key={it.product_id}>{it.qty} × {it.name}</li>)}</ul>
            <p className="flex items-start gap-1.5 text-xs text-slate-500">
              {o.method === "pickup" ? <><Store className="h-3.5 w-3.5" /> Recoger en tienda</> : <><MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" /> {[o.address?.street, o.address?.colony, o.address?.city, o.address?.zip, o.address?.ref].filter(Boolean).join(", ")}</>}
            </p>
            {o.notes && <p className="rounded-lg bg-slate-50 p-2 text-xs text-slate-600">“{o.notes}”</p>}
            {o.payment_status === "paid" && (
              <select value={o.status} onChange={(e) => setStatus(o, e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" data-testid={`order-status-select-${o.id}`}>
                {FLOW.map((s) => <option key={s} value={s}>{ORDER_LABELS[s]}</option>)}
              </select>
            )}
            <p className="text-[11px] text-slate-400">{new Date(o.created_at).toLocaleString("es-MX")}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
